import { DateOnlyInput } from "../components/DateOnlyInput";
import { alphaMutationRejected } from "../alpha-mutation";
import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router";
import { api } from "../api";
import { ErrorState, Loading } from "../ui/State";
import {useAuth} from '../auth';
import {useCapability} from '../ui/StaffSession';
import {Permissions as P} from '@myfm/domain';
export function HandoversAlpha() {
  const {config}=useAuth(),canViewPack=useCapability(P.ViewClientOnboarding);
  const [q] = useSearchParams(),
    building = q.get("building"),
    [model, setModel] = useState<any>(),
    [error, setError] = useState<unknown>(),
    [busy, setBusy] = useState(false),
    pending = useRef<{ url: string; body: any } | null>(null);
  const load = () =>
    building
      ? api("/api/alpha/handovers?building=" + building).then(setModel)
      : Promise.resolve();
  useEffect(() => {
    setModel(undefined);
    void load().catch(setError);
  }, [building]);
  async function save(url: string, body: any) {
    pending.current ??= {
      url,
      body: { ...body, idempotencyKey: crypto.randomUUID() },
    };
    setBusy(true);
    try {
      await api(pending.current.url, {
        method: "POST",
        body: JSON.stringify(pending.current.body),
      });
      pending.current = null;
      setError(undefined);
      await load();
    } catch (e) {
      if (alphaMutationRejected(e)) pending.current = null;
      setError(e);
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <h1>Outgoing managing-agent handovers</h1>
      {building&&config?.buildingOnboardingEnabled&&canViewPack&&<p><Link to={`/buildings/${building}/setup?building=${building}&setupView=handover&handoverDirection=Outgoing`}>Prepare standard and HRB handover checklist</Link>. Delivery and acceptance remain recorded in this outgoing handover case.</p>}
      {Boolean(error) && <ErrorState error={error} />}{" "}
      {pending.current && !busy && (
        <button onClick={() => void save("", {})}>Retry the same save</button>
      )}
      {!building ? (
        <p>Choose a building.</p>
      ) : !model ? (
        <Loading />
      ) : (
        <>
          <form
            className="form"
            onSubmit={(e) => {
              e.preventDefault();
              const f = new FormData(e.currentTarget);
              void save("/api/alpha/handovers/" + f.get("case") + "/start", {
                recipientOrganisationId: f.get("recipient"),
                handoverOn: f.get("date"),
              });
            }}
          >
            <fieldset disabled={busy || !!pending.current}>
              <legend>Start handover</legend>
              <label>
                Handover correspondence
                <select name="case" required>
                  <option value="">Choose case</option>
                  {model.cases.map((c: any) => (
                    <option key={c.id} value={c.id}>
                      {c.title}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Receiving organisation
                <select name="recipient" required>
                  <option value="">Choose organisation</option>
                  {model.organisations.map((o: any) => (
                    <option key={o.id} value={o.id}>
                      {o.legal_name}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Handover date
                <DateOnlyInput name="date" required />
              </label>
              <button>Start handover</button>
            </fieldset>
          </form>
          <Link to={"/alpha/information?building=" + building}>
            Prepare and review the handover document package
          </Link>
          {model.handovers.map((h: any) => (
            <section className="panel" key={h.case_id}>
              <h2>{h.title}</h2>
              <p>
                {h.legal_name} · {h.status} ·{" "}
                {String(h.handover_on).slice(0, 10)}
              </p>
              <p>
                {h.delivery_reference} {h.acceptance_note}
              </p>
              {h.actions.map((a: any) => (
                <p key={a.id}>
                  <Link to={"/work/actions/" + a.id}>{a.title}</Link> ·{" "}
                  {a.status}
                </p>
              ))}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const f = new FormData(e.currentTarget);
                  void save(
                    "/api/alpha/handovers/" +
                      h.case_id +
                      "/" +
                      f.get("command"),
                    { note: f.get("note") },
                  );
                }}
              >
                <fieldset disabled={busy || !!pending.current}>
                  <legend>Record progress</legend>
                  <label>
                    Update
                    <select name="command">
                      <option value="follow-up">Follow-up or query</option>
                      {h.status === "Preparing" && (
                        <option value="delivered">Record delivery</option>
                      )}
                      {h.status === "Delivered" && (
                        <option value="accepted">Record acceptance</option>
                      )}
                    </select>
                  </label>
                  <label>
                    Evidence or correspondence reference and details
                    <textarea
                      name="note"
                      required
                      minLength={10}
                      maxLength={5000}
                    />
                  </label>
                  <button>Save progress</button>
                </fieldset>
              </form>
            </section>
          ))}
        </>
      )}
    </>
  );
}
